import React, { useState } from "react";
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const Fader = styled.div`
    img {width: 100%}
`

const Crossfade = () => {
    const [autoplay] = useState(true);
  const fadeImages = [
    "https://romantic-lewin-770000.netlify.app/static/f436d0674494d03d6bbfcd34680078ac/5634c/market-arch.webp",
    "https://romantic-lewin-770000.netlify.app/static/f436d0674494d03d6bbfcd34680078ac/5634c/market-arch.webp",
    "https://romantic-lewin-770000.netlify.app/static/f436d0674494d03d6bbfcd34680078ac/5634c/market-arch.webp"
  ];
      const data = useStaticQuery(graphql`{
            contentfulHomePage {
                homePagePortraitCarousel {
                    gatsbyImageData(
                        width: 700
                        placeholder: BLURRED
                        layout: CONSTRAINED
                    )
                }
            }
        }
    `)
  return (
      
    <Fader>
      <div className="slide-container">
        <Fade autoplay={autoplay} arrows={false}>
            {data.contentfulHomePage.homePagePortraitCarousel.map(
                    (photo, index) => (
                        <div className="each-fade" key={index}>
                            <div>
                            <GatsbyImage image={photo.gatsbyImageData} />
                            </div>
                        </div>
                    )
                )}
        </Fade>
      </div>
    </Fader>
  );
};

export default Crossfade;